<style>
    .main-box {
        border: 2px solid #dee2e6;
        min-height: 20px;
        background-color: white;
        display: flex;
        flex-direction: column;
        padding: 10px 5px;
        width: 160px;
    }

    .break-line {
        border-bottom: 1px solid #dee2e6;
        margin: 2px 0;
    }

    .box-is-dragged {
        border: 2px dashed #b2adad;
        background-color: #d2d2d2;
    }

    .word-wrap-test {
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        display: block;
    }

    .custom-circle {
        display: inline-flex;
        justify-content: center;
        align-items: center;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        font-size: 15px;
        font-weight: bold;
        text-align: center;
        line-height: 1;
        padding: 0 5px;
    }

    .circle-blue {
        border: 2px solid rgb(39, 39, 237);
        color: rgb(39, 39, 237);
        ;
    }

    .circle-magenta {
        border: 2px solid rgb(148, 0, 158);
        color: rgb(148, 0, 158);
    }

</style>

<!-- box -->
<div class="main-box" (dragenter)="onDragEnter()" (dragleave)="onDragLeave()">

    <div style="flex: 1 1; display:flex; flex-direction: column; align-items: stretch;"
        [class.pointer-events-none]="isDragOver">
        <div style="display: flex; align-items: center; min-width: 0; gap: 2px">
            <div class="custom-circle circle-blue">Z</div>
            <div style="min-width: 0">
                <div class="word-wrap-test">{{ StartDate | date: 'dd.mm.yyyy HH:mm'}}</div>
                <div class="word-wrap-test ">{{StartAddress }}</div>
            </div>
        </div>
        <div style="padding: 2px 5px">
            <div style="background-color: #fafdff; color: gray; cursor: pointer; border: 2px solid #1d0bbe; padding: 2px 5px; border-radius: 30px; display: flex; flex-direction: column; align-items: center; text-align: center;"
                (click)="collapsedCellClicked.emit()">
                <div style="font-weight: 900; font-size: 20px">...</div>
                <div *ngIf="routesCount === 1">zlecenia: {{totalOrdersCount}} </div>
                <div *ngIf="routesCount > 1">
                    <div>zlecenia: {{totalOrdersCount}} </div>
                    <div>/ trasy: {{routesCount}}</div>
                </div>
            </div>
            <div class="break-line" style="display: flex; align-items: center; min-width: 0; gap: 2px">
                <div class="custom-circle circle-magenta">R</div>
                <div style="min-width: 0">
                    <div class="word-wrap-test">{{ EndAddress }}</div>
                </div>
            </div>
            <div>Sum Waga: 10kg</div>
        </div>
    </div>